import { ReactNode, FC } from 'react';
import { FormattedMessage } from 'react-intl';

export interface ValidationErrorsProps {
  isSubmitted: boolean;
  helper?: string | ReactNode;
  errors?: string;
}

const ValidationErrors: FC<ValidationErrorsProps> = ({ errors, helper, isSubmitted }) => {
  return (
    <>
      {errors && isSubmitted ? (
        <div className="text-text-light-bg-discounted-price pt-1 text-xs">
          <FormattedMessage id={`validation:${errors}`} />
        </div>
      ) : (
        <>{helper && <div className="text-text-light-bg-secondary pt-1 text-xs">{helper}</div>}</>
      )}
    </>
  );
};

export default ValidationErrors;
